import { render, staticRenderFns } from "./managementList.vue?vue&type=template&id=78ee0edd&scoped=true"
import script from "./managementList.vue?vue&type=script&lang=js"
export * from "./managementList.vue?vue&type=script&lang=js"
import style0 from "./managementList.vue?vue&type=style&index=0&id=78ee0edd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ee0edd",
  null
  
)

export default component.exports